// extracted by mini-css-extract-plugin
module.exports = {"Content":"LeftColumn_Content__1Br68","Text":"LeftColumn_Text__13LBA","alt":"LeftColumn_alt__l8fR-","white":"LeftColumn_white__10w9j"};